import { Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { PublicService } from './public.service';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as moment from 'moment';
import { createAlertConfig } from '../shared/factoryconfigAlert';

@Component({
  selector: 'public-user-register',
  templateUrl: './public-user-register.component.html',
  styleUrls: ['./public-user-register.component.css']
})
/** public-user-register component*/
export class PublicUserRegisterComponent implements OnInit {

  @ViewChild('addSocioForm', { static: true })
  formSendAdd: NgForm;

  socio: any;
  associazione: any;

  dateModel: Date;

  nazioni: any[];
  associazioni: any[];

  yearRange: string = "1900:2040"

  showSuccess: boolean = false;

  /** public-user-register ctor */
  constructor(@Inject(LOCALE_ID) public locale: string,
    private publicService: PublicService, private alertservice: NwbAlertService,
    private route: ActivatedRoute) {


  }

  ngOnInit(): void {
    let currentYear = moment().year();
    this.yearRange = `${(currentYear - 110)}:${currentYear}`;

    this.route.data.subscribe(t => {
      this.nazioni = t.data[0];
      this.associazioni = t.data[1];
      this.socio = {
        sesso: 'M',
        codStato: 'IT'
      };
    });
  }

  addSocio() {
    if (this.formSendAdd.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }

    let m = moment(this.dateModel);
    this.socio.natoIl = m.format('YYYY-MM-DD');
    this.publicService.addSocio(this.socio).subscribe(() => {
      this.showSuccess = true;
      this.socio.accept = false;
      this.formSendAdd.reset();
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 10);
    }, error => {
      if (error.error) {
        this.alertservice.open(createAlertConfig(error.error, false)).afterClosed().subscribe();
        return;
      }

      if (this.locale == 'it') {
        this.alertservice.open(createAlertConfig("Errore non gestito. Provare a ricaricare la pagina. Se persiste contattare l'assistenza", false)).afterClosed().subscribe();
      } else {
        this.alertservice.open(createAlertConfig("Error not manage. Try to reload the current page. If persist contact the support", false)).afterClosed().subscribe();
      }
    });
  }

  onChangeAssociazione(event: any) {
    if (event) {
      let associazioneNuova = this.associazioni.find(a => a.id == event);
      this.socio.idAssociazione = associazioneNuova.id;
      this.socio.nomeAssociazione = associazioneNuova.ragioneSociale;
    } else {
      this.socio.idAssociazione = this.socio.tesseraAssociazione = this.socio.nomeAssociazione = undefined;
    }
  }
}
